export async function handle(response: any) {
  if (response.error) {
    throw response.error.message;
  }
  return response.data;
}
